import React from 'react'
import { Row, Col } from 'react-bootstrap';
import SelectFild from '../../components/SelectFild/SelectFild';
import DateFild from '../../components/DateTimePicker/DateFild';
import { useFormik } from 'formik';
import { postProjectSave } from '../../apiservices/ApiServices';

const StepOne = (props) => {
    const initialValues = {
        projectCategoryId: props.editData?.general_information?.proj_category_id || '',
        billingEntityId: props.editData?.general_information?.billing_entity_id || '',
        clientId: props.editData?.general_information?.client_id || '',
        startDate: props.editData?.general_information?.start_date || '',
        endDate: props.editData?.general_information?.end_date || '',
        projectComplexity: props.editData?.general_information?.proj_complexity_id || '',
        projectFrequency: props.editData?.general_information?.proj_frequency_id || '',
        projectSchedule: props.editData?.general_information?.proj_renewal_type || '',
        projectScheduleCount: props.editData?.general_information?.proj_renewal_count || '',
    }
    const formik = useFormik({
        initialValues: initialValues,
        validationSchema: '',
        onSubmit: async (values) => {
            props.setLoadings(true);
            let postData = {
                project_id: props.ids,
                step: 'general_information',
                data: {
                    proj_category_id: values.projectCategoryId,
                    billing_entity_id: values.billingEntityId,
                    client_id: values.clientId,
                    start_date: values.startDate,
                    end_date: values.endDate,
                    proj_complexity_id: values.projectComplexity,
                    proj_frequency_id: values.projectFrequency,
                    proj_renewal_type: values.projectSchedule,
                    proj_renewal_count: values.projectScheduleCount,
                }
            }

            try {
                const res = await postProjectSave(postData);
                props.Toast.success(res.data.message);
                let proid = res?.data?.data?.project_id;
                props.setIds(proid);
                props.postProjectLists(proid);
                props.setLoadings(false);
                props.setStep(2);

            } catch (error) {
                props.setLoadings(false);
                props.Toast.error(error.response?.data?.message || "Error submitting data");
            }
        }
    });
    const { values, handleChange, handleBlur, handleSubmit, setFieldValue, errors, touched } = formik;

    return (
        <form onSubmit={handleSubmit} autoComplete="off">
            <div className='fieldsets cols_5'>
                <div className='fieldsets-title'>Project General Information</div>
                <Row>
                    <Col md={3}>
                        <div className="form-group">
                            <label className="form-label">Project Category</label>
                            <SelectFild
                                Firstop='Select Project Category'
                                selectName="projectCategoryId"
                                options={props.commonMaster?.project_category}
                                value={values.projectCategoryId}
                                onChange={(selectedOption) => setFieldValue("projectCategoryId", selectedOption?.value || "")}
                                onBlur={handleBlur}
                            />
                            {errors.projectCategoryId && touched.projectCategoryId && (
                                <p className="errormsg">{errors.projectCategoryId}</p>
                            )}
                        </div>
                    </Col>
                    <Col md={3}>
                        <div className="form-group">
                            <label className="form-label">Billing Entity</label>
                            <SelectFild
                                Firstop='Select Billing Entity'
                                selectName="billingEntityId"
                                options={props.commonMaster?.billing_entity}
                                value={values.billingEntityId}
                                onChange={(selectedOption) => setFieldValue("billingEntityId", selectedOption?.value || "")}
                                onBlur={handleBlur}
                            />
                            {errors.billingEntityId && touched.billingEntityId && (
                                <p className="errormsg">{errors.billingEntityId}</p>
                            )}
                        </div>
                    </Col>
                    <Col md={3}>
                        <div className="form-group">
                            <label className="form-label">Client</label>
                            <SelectFild
                                Firstop='Select Client'
                                selectName="clientId"
                                options={props.commonMaster?.clients}
                                value={values.clientId}
                                onChange={(selectedOption) => setFieldValue("clientId", selectedOption?.value || "")}
                                onBlur={handleBlur}
                            />
                            {errors.clientId && touched.clientId && (
                                <p className="errormsg">{errors.clientId}</p>
                            )}
                        </div>
                    </Col>
                    <Col md={3}>
                        <div className="form-group">
                            <label className="form-label">Start Date</label>
                            <DateFild
                                value={values.startDate}
                                onChange={(date) => setFieldValue('startDate', date)}
                            />
                            {errors.startDate && touched.startDate && (
                                <p className="errormsg">{errors.startDate}</p>
                            )}
                        </div>
                    </Col>
                    <Col md={3}>
                        <div className="form-group">
                            <label className="form-label">End Date</label>
                            <DateFild
                                value={values.endDate}
                                onChange={(date) => setFieldValue('endDate', date)}
                            />
                            {errors.endDate && touched.endDate && (
                                <p className="errormsg">{errors.endDate}</p>
                            )}
                        </div>
                    </Col>
                    <Col md={3}>
                        <div className="form-group">
                            <label className="form-label">Project Complexity</label>
                            <SelectFild
                                Firstop='Select Project Complexity'
                                selectName="projectComplexity"
                                options={props.commonMaster?.project_complexity}
                                value={values.projectComplexity}
                                onChange={(selectedOption) => setFieldValue("projectComplexity", selectedOption?.value || "")}
                                onBlur={handleBlur}
                            />
                            {errors.projectComplexity && touched.projectComplexity && (
                                <p className="errormsg">{errors.projectComplexity}</p>
                            )}
                        </div>
                    </Col>
                    <Col md={3}>
                        <div className="form-group">
                            <label className="form-label">Project Frequency</label>
                            <SelectFild
                                Firstop='Select Project Frequency'
                                selectName="projectFrequency"
                                options={props.commonMaster?.project_frequency}
                                value={values.projectFrequency}
                                onChange={(selectedOption) => setFieldValue("projectFrequency", selectedOption?.value || "")}
                                onBlur={handleBlur}
                            />
                            {errors.projectFrequency && touched.projectFrequency && (
                                <p className="errormsg">{errors.projectFrequency}</p>
                            )}
                        </div>
                    </Col>
                    {values.projectFrequency == '68' &&
                        <Col md={3}>
                            <div className="form-group">
                                <label className="form-label">Project Schedule</label>
                                <ul className='radiolist'>
                                    {props.commonMaster?.project_renewal_type?.map((item) => (
                                        <li>
                                            <div className='radioBox'>
                                                <input
                                                    type="radio"
                                                    name="projectSchedule"
                                                    value={item.name}
                                                    checked={values.projectSchedule == item.name}
                                                    onChange={handleChange}
                                                />
                                                <span className='rdoMark'></span>
                                                <label>{item.name}</label>
                                            </div>
                                        </li>
                                    ))}
                                </ul>
                                {errors.projectSchedule && touched.projectSchedule && (
                                    <p className="errormsg">{errors.projectSchedule}</p>
                                )}
                            </div>
                        </Col>
                    }
                    {values.projectFrequency == '68' && values.projectSchedule != '' &&
                        <Col md={3}>
                            <div className="form-group">
                                <label className="form-label">Project Renewal Count </label>
                                <input
                                    type='text'
                                    id="projectScheduleCount"
                                    name="projectScheduleCount"
                                    className="form-control"
                                    autoComplete='off'
                                    value={values.projectScheduleCount}
                                    onChange={handleChange}
                                    onBlur={handleBlur}
                                />
                                {errors.projectScheduleCount && touched.projectScheduleCount && (
                                    <p className="errormsg">{errors.projectScheduleCount}</p>
                                )}
                            </div>
                        </Col>
                    }
                </Row>
                <div className='button-boxs grid'>
                    <button type='submit' className='btn btn-primary'>Save</button>
                </div>
            </div>
        </form>
    )
}

export default StepOne